import React from "react";
import PropTypes from "prop-types";
import PercentageCell from "./PercentageCell";
import { IonItem, IonLabel, IonList } from "@ionic/react";
import TotalPointsStatsBar from "./TotalPointsStatsBar";
import SinglePointStatsBar from "./SinglePointStatsBar";

function PointStats(props) {
  return (
    <div className="ion-padding PointStats">
      <h2 className="ion-text-center">Statistiche dei Colpi</h2>
      <div style={{ minHeight: "120px", width: "100%", position: "relative" }}>
        <TotalPointsStatsBar data={props.data} />
      </div>
      <h2>Dritto</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Vincente
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.winner.forehand}
            total={props.data.totals.forehand}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-warning)" }}>
          <IonLabel style={{ color: "var(--ion-color-warning)" }}>
            Forzato
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.forced.forehand}
            total={props.data.totals.forehand}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Gratuito
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.error.forehand}
            total={props.data.totals.forehand}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell value={props.data.totals.forehand} />
        </IonItem>
        <div
          style={{ minHeight: "120px", width: "100%", position: "relative" }}
        >
          <SinglePointStatsBar
            data={props.data}
            type="forehand"
            title="Dritto"
          />
        </div>
      </IonList>
      <h2>Rovescio</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Vincente
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.winner.backhand}
            total={props.data.totals.backhand}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-warning)" }}>
          <IonLabel style={{ color: "var(--ion-color-warning)" }}>
            Forzato
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.forced.backhand}
            total={props.data.totals.backhand}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Gratuito
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.error.backhand}
            total={props.data.totals.backhand}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell value={props.data.totals.backhand} />
        </IonItem>
        <div
          style={{ minHeight: "120px", width: "100%", position: "relative" }}
        >
          <SinglePointStatsBar
            data={props.data}
            type="backhand"
            title="Rovescio"
          />
        </div>
      </IonList>
      <h2>Volée</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Vincente
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.winner.volley}
            total={props.data.totals.volley}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-warning)" }}>
          <IonLabel style={{ color: "var(--ion-color-warning)" }}>
            Forzato
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.forced.volley}
            total={props.data.totals.volley}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Gratuito
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.error.volley}
            total={props.data.totals.volley}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell value={props.data.totals.volley} />
        </IonItem>
        <div
          style={{ minHeight: "120px", width: "100%", position: "relative" }}
        >
          <SinglePointStatsBar data={props.data} type="volley" title="Volée" />
        </div>
      </IonList>
      <h2>Smash</h2>
      <IonList>
        <IonItem style={{ color: "var(--ion-color-success)" }}>
          <IonLabel style={{ color: "var(--ion-color-success)" }}>
            Vincente
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.winner.smash}
            total={props.data.totals.smash}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-warning)" }}>
          <IonLabel style={{ color: "var(--ion-color-warning)" }}>
            Forzato
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.forced.smash}
            total={props.data.totals.smash}
          />
        </IonItem>
        <IonItem style={{ color: "var(--ion-color-danger)" }}>
          <IonLabel style={{ color: "var(--ion-color-danger)" }}>
            Gratuito
          </IonLabel>
          <PercentageCell
            className="ion-flex"
            value={props.data.error.smash}
            total={props.data.totals.smash}
          />
        </IonItem>
        <IonItem>
          <IonLabel>Totale</IonLabel>
          <PercentageCell value={props.data.totals.smash} />
        </IonItem>
        <div
          style={{ minHeight: "120px", width: "100%", position: "relative" }}
        >
          <SinglePointStatsBar data={props.data} type="smash" title="Smash" />
        </div>
      </IonList>
    </div>
  );
}

PointStats.propTypes = {
  data: PropTypes.shape({
    winner: PropTypes.shape({
      forehand: PropTypes.number.isRequired,
      backhand: PropTypes.number.isRequired,
      volley: PropTypes.number.isRequired,
      smash: PropTypes.number.isRequired,
    }).isRequired,
    forced: PropTypes.shape({
      forehand: PropTypes.number.isRequired,
      backhand: PropTypes.number.isRequired,
      volley: PropTypes.number.isRequired,
      smash: PropTypes.number.isRequired,
    }).isRequired,
    error: PropTypes.shape({
      forehand: PropTypes.number.isRequired,
      backhand: PropTypes.number.isRequired,
      volley: PropTypes.number.isRequired,
      smash: PropTypes.number.isRequired,
    }).isRequired,
    totals: PropTypes.shape({
      forehand: PropTypes.number.isRequired,
      backhand: PropTypes.number.isRequired,
      volley: PropTypes.number.isRequired,
      smash: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default PointStats;
